<template>
  <div :class="['object-settings']" :style="style">
    <span class="round-button close-button" @click="close">X</span>
    
    <div class="field">
      <div class="label">Background colour:</div>
      <div>
        <input type="color" v-model="backgroundColour" @blur="chooseColour" name="" id="">
      </div>
    </div>

    <div class="field">
      <div class="label">Text colour:</div>
      <div>
        <input type="color" v-model="textColour" @blur="chooseColour" name="" id="">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      backgroundColour: '#ffffff',
      textColour: '#000000'
    }
  },
  methods: {
    chooseColour(colour) {
      this.$parent.update({
        backgroundColour: this.backgroundColour,
        textColour: this.textColour
      })

      this.data.backgroundColour =  this.backgroundColour,
      this.data.textColour = this.textColour
    },
    close() {
      this.$parent.showingSettings = false;
    }
  },
  computed: {
    style: function() {
      return `
        width:${this.width - 10}px;
        background-color:${this.data.backgroundColour};
      `;
    }
  },
  created() {
    this.backgroundColour = this.data.backgroundColour;
    this.textColour = this.data.textColour;
  }
}
</script>

<style scoped>

.object-settings {
  margin: 5px 0 0 0;
  padding: 5px;
  border-radius: 6px;
}


.close-button {
  position: absolute;
  right: 5px;
  background-color: rgb(182, 1, 1);
  color: white!important;
}

.close-button:hover {
  background-color: rgb(109, 0, 0);
}

.field {
  padding: 0 50px 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/ObjectSettings.vue